/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Tab_Allow_OverageInputs */



/**
* | output |
* | --- |
* | "Allow overage spending" |
*
* @param {Usage_Tab_Allow_OverageInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const usage_tab_allow_overage = /** @type {((inputs?: Usage_Tab_Allow_OverageInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Tab_Allow_OverageInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Überschuss-Ausgaben erlauben")
	return /** @type {LocalizedString} */ ("Allow overage spending")
});